import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const GiftIcon: React.FC<DefaultIconProps> = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_174_2603)">
      <g opacity="0.4">
        <path d="M9.57002 12.46L6.52002 15.51" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.55005 12.49L9.60005 15.54" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <path opacity="0.4" d="M13.53 14H13.5404" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path opacity="0.4" d="M17.47 14H17.4804" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path opacity="0.4" d="M15.5 15.9801V15.96" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path opacity="0.4" d="M15.5 12.0402V12.02" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 22H15C20 22 22 20 22 15V13C22 8 20 6 15 6H9C4 6 2 8 2 13V15C2 20 4 22 9 22Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.01 2L13 3.01C12.9974 3.27348 12.8908 3.52527 12.7036 3.71065C12.5163 3.89603 12.2635 4.00001 12 4H11.97C11.7048 4.00133 11.4509 4.10795 11.2643 4.29643C11.0777 4.4849 10.9737 4.73978 10.975 5.005C10.9763 5.27022 11.0829 5.52404 11.2714 5.71064C11.4599 5.89724 11.7148 6.00133 11.98 6H12.98" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_174_2603">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

export default GiftIcon;
